export default {
    debug: false,
    directives: {
        connectSrc: [
            "api.oldcity.tours", "www.oldcity.tours", "cdn.touryup.com",
            "*.elfsight.com",
            "www.facebook.com",
            "www.google-analytics.com",
            "www.googletagmanager.com",
            "google.com",
            "*.google.com",
            "stats.g.doubleclick.net",
            "mc.yandex.ru",
            "cdn.linkedin.oribi.io",
            "pagead2.googlesyndication.com",
            "idb.iubenda.com"
        ],
        defaultSrc: [
            "cdn.touryup.com",
            "www.dropbox.com",
            "*.dl.dropboxusercontent.com",
            "bid.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "phosphor.utils.elfsightcdn.com",
            "*.cdninstagram.com"
        ],
        imgSrc: [
            "blob:", "cdn.touryup.com", "www.oldcity.tours",
            "*.tripadvisor.com", '*.tile.osm.org',

            "www.facebook.com", "connect.facebook.com", "connect.facebook.net",

            "googleads.g.doubleclick.net", "www.google.com", "www.google.az", 'www.google.me', 'www.google.nl',
            "*.google-analytics.com", "*.googletagmanager.com",
            "ssl.google-analytics.com", "stats.g.doubleclick.net",
            "ssl.gstatic.com", "www.gstatic.com", "*.googleadservices.com",
            "fonts.gstatic.com",

            "px.ads.linkedin.com", "www.linkedin.com",

            "mc.yandex.ru",
            "static.elfsight.com",
            "phosphor.utils.elfsightcdn.com"
        ],
        fontSrc: [
            "data:",
            "fonts.gstatic.com",
        ],
        // frameSrc: [
        //     "www.youtube.com",
        //     "drive.google.com",
        //     "www.dropbox.com",
        //     "*.dl.dropboxusercontent.com",
        //     'www.facebook.com',
        //     "bid.g.doubleclick.net", "tpc.googlesyndication.com",
        //     "td.doubleclick.net"
        // ],
        scriptSrc: [
            "blob:",
            "tagmanager.google.com",
            "*.googletagmanager.com",
            "www.google-analytics.com", "ssl.google-analytics.com",
            "www.google-analytics.com",
            "www.googleadservices.com",
            "google.com",
            "www.google.com",
            "googleads.g.doubleclick.net",
            "tpc.googlesyndication.com",
            "connect.facebook.net",
            "mc.yandex.ru", "book.touryup.com"
        ],
        styleSrc: [
            "tagmanager.google.com", "fonts.googleapis.com", "book.touryup.com"
        ],
        //frameSrc: ['self', "book.touryup.com", "checkout.cibpay.co"],
        frameAncestors: ["'self'", "book.touryup.com", "checkout.cibpay.co"],
        frameSrc: ['*'],
    },
    google: {
        tagManagerId: 'GTM-55ZB5WTJ',
        //analyticsId: 'G-3C9NGEQN84',
    },
    robots: "index, follow",
    meta: [
        {name: 'theme-color', content: '#000'},
        {name: 'facebook-domain-verification', content: 'z8t8f3hgkd7mm0370taj50zbd3vgcg'}
    ],
}
